import React, { useState , useMemo , useEffect} from 'react';
import { useSelector } from 'react-redux';
import clearFilter from '../assets/ClearFilter.svg'
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useLocation } from 'react-router-dom';
import "../styles/screens/HomeScreen.scss"
import Pagination from '@mui/material/Pagination';
import NewDateandTimePicker from './NewDateandTimePicker';
import {
  useGetCreditRechargeTransactionHistoryQuery,
} from "../slices/getqueries/getqueriesApi";
import {format} from 'date-fns';
import Skeleton from '@mui/material/Skeleton';
import { toast } from "react-toastify";
import { formatINRCurrencyWithDecimals } from '../numberFormatter';
const Transactions = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { clientId } = userInfo;
    const navigate = useNavigate();
    const [transactionIdInput, setTransactionIdInput] = useState('');
    const [dateRangeInput, setDateRangeInput] = useState(null);

    
      const handleBack = () => {
        navigate(-1);
      };

      const [txPage, setTxPage] = useState(1);
      const txLimit = 15;
      const txOffset = (txPage - 1) * txLimit;

      const [transactionId, setTransactionId] = useState('');
      const [dateRange, setDateRange] = useState(null);

      const {
        data: txData,
        isLoading: isTxLoading,
        isError: isTxError,
        isFetching:isTxFetching,
        refetch,
      } = useGetCreditRechargeTransactionHistoryQuery({
        clientname: clientId,
        limit: txLimit,
        offset: txOffset,
        ...(transactionId && { transactionId }),
        ...(dateRange && {
          fromDate: format(dateRange[0], 'yyyy-MM-dd'),
          toDate: format(dateRange[1], 'yyyy-MM-dd'),
        }),
      });

      
      const paginatedTransactions = useMemo(() => {
        if (!txData || !Array.isArray(txData.transactionHistoryData)) return [];
        return txData.transactionHistoryData.map((tx) => ({
          id: tx.transactionId,
          date: tx.transactionDate, 
          time: tx.transactionTime, 
          amount: `₹${tx.transactionAmount.toLocaleString('en-IN')}`,
          remaining: `₹${tx.creditBalance.toLocaleString('en-IN')}`,
          paymentType: tx.paymentType,
        }));
      }, [txData]);

      console.log(paginatedTransactions)
      const totalTxPages = Math.ceil((txData?.totalCount || 0) / txLimit);
      
      const handleTxPageChange = (event, value) => {
        setTxPage(value);
      };
      
      const handleResetFilters = async () => {
        setTransactionIdInput('');
        setDateRangeInput(null);
        setTransactionId('');
        setDateRange(null);
        setTxPage(1);
      };
      
      const handleApplyFilters = () => {
        const noFiltersSelected = !transactionIdInput && !dateRangeInput;

        if (noFiltersSelected) {
          handleResetFilters();
          return;
        }
        setTransactionId(transactionIdInput);
        setDateRange(dateRangeInput);
        setTxPage(1);
      };


      const setDataRange = (value) => {
        if (value && value.length === 2) {
          const [startDate, endDate] = value;
          console.log('Start Date:', startDate.toLocaleDateString());
          console.log('End Date:', endDate.toLocaleDateString());
          setDataRange(value);
        } else {
          setDataRange(null);
          console.log('No date range selected');
        }
      };
      useEffect(() => {
        if (!isTxFetching) {
        if (txData) {
            toast.success("Data Fetched successfully!");
          }
        }
      }, [isTxError, isTxFetching, txData]);
  return (
    <>
      <div className="flex items-center gap-3 text-xl font-semibold mb-4">
      <FaArrowLeftLong className="w-10 h-10 text-gray-700 hover:text-black transition cursor-pointer" onClick={handleBack}/>
        <h1 className='font-[600] text-[24px]'>Transactions History</h1>
      </div>
      {isTxLoading ? (
  <div className="bg-[#204887] text-white">
  <div className="flex flex-col gap-2 w-full md:w-[48%]">
    <Skeleton variant="text" width={150} height={20} animation="wave" sx={{ bgcolor: 'white' }} />
    <Skeleton variant="text" width={180} height={28} animation="wave" sx={{ bgcolor: 'white' }} />
  </div>
  <div className="flex flex-col gap-2 w-full md:w-[48%] mt-4 md:mt-0">
    <Skeleton variant="text" width={160} height={20} animation="wave" sx={{ bgcolor: 'white' }} />
    <Skeleton variant="text" width={200} height={28} animation="wave" sx={{ bgcolor: 'white' }} />
  </div>
</div>

) : (
  <div className="flex flex-col md:flex-row md:gap-[90px] bg-[#204887] text-white p-6 rounded-[15px] mb-6">
    <div className="flex flex-row items-center justify-between gap-2 md:block">
      <p className="text-[14px] font-[500] break-words md:mb-1">Total Transactions Amount</p>
      <h2 className="text-[20px] font-[700] break-all">{formatINRCurrencyWithDecimals(txData?.totalTransactionAmount)}</h2>
    </div>
    <div className="flex flex-row items-center justify-between gap-2 md:block mt-2 md:mt-0">
      <p className="text-[14px] font-[500] break-words md:mb-1">Total Remaining Amount</p>
      <h2 className="text-[20px] font-[700] break-all">{formatINRCurrencyWithDecimals(txData?.totalRemainingBalance)}</h2>
    </div>
  </div>
)}

      <div className="flex flex-col lg:flex-row gap-6 w-full">
        <div className="bg-white rounded-[15px] shadow p-4 w-full lg:w-[20%]">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-[600] text-[20px]">Filters</h3>
            <img
              src={clearFilter}
              alt="Reset Filters"
              className="w-8 h-8 cursor-pointer"
              onClick={handleResetFilters}
              title="Clear Filters"
            />
          </div>
          <div className="space-y-4 md:grid md:grid-cols-2 md:items-end md:gap-3 lg:grid lg:grid-cols-1">
            
            <div className='space-y-4'>
            <p className='text-[#4B5563] font-[500] text-[12px]'>Transactions Id</p>
            <input type="text" className="w-full border p-4 rounded-[10px] text-[#6B7280]" placeholder="Enter Transaction Id" value={transactionIdInput} onChange={(e) => setTransactionIdInput(e.target.value)}/>
            </div>
            <div className="space-y-4">
            <p className='text-[#4B5563] font-[500] text-[12px]'>Transaction Date</p>
            <NewDateandTimePicker
           value={dateRangeInput}
          onDateRangeChange={(value) => {
          setDateRangeInput(value);      
          setTxPage(1);              
          }}
          />
            </div>
            <div className='sm:w-[25%] md:w-[50%] lg:w-full'>
            <button className="w-full bg-[#204887] text-white py-4 rounded-[10px] mt-2 text-[12px]" onClick={handleApplyFilters}>Apply</button>
            </div>
          </div>
        </div>
      <div className="bg-white rounded-[15px] shadow p-4 overflow-auto w-full lg:w-[80%]">
    {isTxLoading ? (
      <>
  <table className="w-full min-w-[800px] text-[14px] rounded-[10px]">
    <thead className="bg-[#E5EFFF] text-[#204887]">
      <tr className="text-center font-semibold">
        <th className="customized-table-header">Transaction Id</th>
        <th className="customized-table-header">Transaction Date</th>
        <th className="customized-table-header">Transaction Time</th>
        <th className="customized-table-header">Transaction Amount</th>
        <th className="customized-table-header">Payment Type</th>
        <th className="customized-table-header">Remaining Amount</th>
      </tr>
    </thead>
    <tbody>
      {Array.from({ length: 10 }).map((_, index) => (
        <tr key={index}>
          <td className="customized-table-value text-center">
            <Skeleton variant="text" width={100} height={20} animation="wave" />
          </td>
          <td className="customized-table-value text-center">
            <Skeleton variant="text" width={100} height={20} animation="wave" />
          </td>
          <td className="customized-table-value text-center">
            <Skeleton variant="text" width={80} height={20} animation="wave" />
          </td>
          <td className="customized-table-value text-center">
            <Skeleton variant="text" width={120} height={20} animation="wave" />
          </td>
          <td className="customized-table-value text-center">
            <Skeleton variant="text" width={80} height={20} animation="wave" />
          </td>
          <td className="customized-table-value text-center">
            <Skeleton variant="text" width={130} height={20} animation="wave" />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
  <div className="flex justify-center mt-4">
    <Skeleton variant="rectangular" width={220} height={40} animation="wave" sx={{ borderRadius: "10px" }} />
  </div>
</>
    ) : paginatedTransactions?.length === 0 ? (
      <div className="text-gray-600 flex items-center justify-center sm:mt-[8%] sm:mb-[8%] md:mt-[8%] md:mb-[8%] text-[15px] py-10">No Data Found</div>
    ) : (
      <>
        <table className="w-full min-w-[800px] text-[14px] rounded-[10px] table-fixed">
          <thead className="bg-[#E5EFFF] text-[#204887]">
            <tr className="text-center font-semibold">
              <th className="customized-table-header">Transaction Id</th>
              <th className="customized-table-header">Transaction Date</th>
              <th className="customized-table-header">Transaction Time</th>
              <th className="customized-table-header">Transaction Amount</th>
              <th className="customized-table-header">Payment Type</th>
              <th className="customized-table-header">Remaining Amount</th>
            </tr>
          </thead>
          <tbody>
            {paginatedTransactions.map((tx, index) => (
              <tr key={index}>
                <td className="customized-table-value break-words">{tx.id}</td>
                <td className="customized-table-value">{tx.date}</td>
                <td className="customized-table-value">{tx.time}</td>
                <td className="customized-table-value break-words">{formatINRCurrencyWithDecimals(tx.amount)}</td>
                <td className="customized-table-value">{tx.paymentType}</td>
                <td className="customized-table-value break-words">{formatINRCurrencyWithDecimals(tx.remaining)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {totalTxPages > 1 && (
          <div className="flex justify-center mt-4">
            <Pagination
              count={totalTxPages}
              page={txPage}
              onChange={handleTxPageChange}
              showFirstButton
              showLastButton
              siblingCount={1}
              boundaryCount={1}
              color="primary"
              size="medium"
              sx={{
                '& li': {
                  border: 'none',
                  boxShadow: 'none',
                  margin: 0,
                  padding: 0,
                },
                '& .MuiPaginationItem-root': {
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                },
              }}
            />
          </div>
        )}
      </>
    )}
  </div>
      </div>
    </>
  );
};

export default Transactions;
